import React from "react";
import PropTypes from "prop-types";
import InputMask from "react-input-mask";
import classnames from "classnames";
import {COUNTRY_CODE_PL} from "../utils/country";
import {useTranslation} from "react-i18next";

export default function InputMaskPostalCode(props) {
  const { t } = useTranslation('postal_code_input');
  const [value, setValue] = React.useState(props.value);
  const onChange = (e) => setValue(e.target.value.replace(/[^\d\w\-]+/g, ''));

  React.useEffect(() => props.onChange(value), [value]);
  React.useEffect(() => setValue(props.value), [props.value]);

  const getMask = () => {
    switch(props.countryCode) {
      case COUNTRY_CODE_PL: {
        return "99-999";
      }
      default: {
        return null
      }
    }
  }

  return <InputMask
    className={classnames({
      [`form-control form-control-${props.size}`]: true,
      'is-invalid': props.invalid,
    })}
    placeholder={t('placeholder')}
    mask={getMask()}
    onChange={onChange}
    value={value}
  />
};

InputMaskPostalCode.defaultProps = {
  size: 'md',
  value: '',
  invalid: false,
};

InputMaskPostalCode.propTypes = {
  size: PropTypes.string,
  countryCode: PropTypes.string,
  invalid: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
